<section class="lp-countries-accordion">
  <div class="row">
    <div class="col-12">
      <div class="lp-countries-accordion-wrapper">
        <div
          class="lp-countries-accordion-item"
          *ngFor="let accordionItem of accordionSet; let index = index"
          [ngClass]="accordionSet[index]?.status ? 'open' : 'closed'"
        >
          <div class="lp-countries-accordion-item-header">
            <div class="lp-countries-accordion-item-header-title">
              <h3>{{ accordionItem.title }}</h3>
            </div>
            <div class="lp-countries-accordion-item-header-control">
              <button
              aria-label="Toggle Accordion"
                class="lp-countries-accordion-item-header-control-s"
                (click)="
                  accordionSet[index].status = !accordionSet[index].status
                "
              >
                <i class="fas fa-plus" *ngIf="!accordionSet[index].status"></i>
                <i class="fas fa-minus" *ngIf="accordionSet[index].status"></i>
                <!-- <span *ngIf="!accordionSet[index].status">+</span>
                <span *ngIf="accordionSet[index].status">-</span> -->
              </button>
            </div>
          </div>
          <div class="lp-countries-accordion-item-content">
            <div class="lp-countries-accordion-item-content-left">
              <h3>{{ accordionItem.title }}</h3>
            </div>
            <div class="lp-countries-accordion-item-content-divider"></div>
            <div class="lp-countries-accordion-item-content-right">
              <p [innerHTML]="accordionItem.content">
              </p>
              <button
              aria-label="Accordion CTA Button"
                class="btn lp-accordion-cta-btn"
                *ngIf="accordionItem.isBtn" (click)="goToTarget(accordionItem.buttonTarget)"
              >
                {{ accordionItem.buttonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
